export default "__VITE_ASSET___4WZVAeF__"